import { useTranslation } from "react-i18next";

import {
  DropdownGlobal,
  IDropDown,
} from "../../../../../components/DropdownGlobal";

interface WatermarkProviderProps {
  listWaterMarkProvider: Array<IDropDown>;
  fieldError: boolean;
  setEditedValue: (e: string) => void;
  getNameIfIdMatches: (array: any[], editedValue: string) => string;
  editedValue: string;
}

const WatermarkProvider = ({
  listWaterMarkProvider,
  fieldError,
  setEditedValue,
  getNameIfIdMatches,
  editedValue,
}: WatermarkProviderProps) => {
  const { t } = useTranslation();
  return (
    <>
      <DropdownGlobal
        labelName={t("systemConfiguration.watermark.provider")}
        options={listWaterMarkProvider}
        error={fieldError}
        setSelected={setEditedValue}
        required={false}
        editDropdown={getNameIfIdMatches(listWaterMarkProvider, editedValue)}
        defaultValue={getNameIfIdMatches(listWaterMarkProvider, editedValue)}
      />
    </>
  );
};

export default WatermarkProvider;
